var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.815,
    height: 23.044,
    viewBox: "0 0 22.815 23.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_2_",
    "data-name": "search (2)",
    transform: "translate(-16.641 -14.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 9.582,
    cy: 9.582,
    r: 9.582,
    transform: "translate(19.791 15)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_503",
    "data-name": "Line 503",
    y1: 5.48,
    x2: 5.25,
    transform: "translate(17.348 31.357)",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.10172190a4b9771f2bf55a31905810b7.svg";
export { ForwardRef as ReactComponent };